var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "db") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.856 13.377c-0.838 0.338-1.355 0.678-1.176 1.355 0 1.32 5.176 2.482 11.389 2.482 3.873 0 7.373-0.982 9.391-1.643l-0.66 4.373c-1.838 0.982-5.873 1.963-10.391 1.963-2.857 0-5.355-0.32-7.373-0.82-1.018 0.5-1.695 0.82-1.695 1.34 0 1.355 3.713 2.355 9.391 2.355 3.535 0 7.711-1.16 9.551-1.838l-0.66 3.998c-1.695 0.84-5.213 1.875-9.391 1.875-4.516 0-8.551-1.5-9.873-2.518l-0.697-4.195v-0.197c0-0.463 0.84-0.98 2.020-1.301-1-0.34-1.68-0.662-2.16-1.037l-0.857-5.177v-0.178c0-0.518 0.518-0.982 1.5-1.322-0.822-0.178-1.303-0.516-1.822-0.855l-0.838-5.856v-0.18c0-1.518 5.533-2.82 12.568-2.82 4.195 0 7.711 0.465 10.051 1.16-2.195-0.518-5.016-0.695-8.051-0.695-7.016 0-12.551 1.355-12.551 2.855 0 1.518 5.676 2.855 12.551 2.855 4.355 0 8.211-0.516 10.426-1.338l-0.715 4.357c-1.965 0.998-6.355 1.82-11.371 1.82-3.375 0-6.375-0.322-8.551-0.822l-0.004 0.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityDb);
export default __webpack_public_path__ + "static/media/unity_db.8b5c896781833dac53313166ea706b07.svg";
export { ForwardRef as ReactComponent };